<template>
  <div class='installation'>
    <figure>
      <picture-module :image='image'
                      sizes='(max-width: 700px) 90vw, (max-width: 1600px) 30vw, (min-width: 1600px) 39em, 240px' />
    </figure>
    <article>
      <h2>{{ title }}</h2>
      <h3 v-if="meta && time">({{ meta }}, {{ time }})</h3>
      <h3 v-if="meta && !time">({{ meta }})</h3>
      <h3 v-if="!meta && time">({{ time }})</h3>
      <h4 v-if="type">{{ type }}</h4>
      <nav
        v-if='readmore || view'
        class='links'>
        <a
          v-if='readmore'
          class='readmore'
          :href='readmore'
          target='_blank'>
          Read more
        </a>
        <router-link
          v-if='view'
          class='view'
          :to='view'>
          View {{ type }}
        </router-link>
      </nav>
    </article>
  </div>
</template>

<script>
module.exports = {
  props: ['title', 'meta', 'time', 'type', 'view', 'readmore', 'image']
}
</script>

<style>
  div.installation {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
    border-bottom: 1px solid silver;
  }

  div.installation h2, div.installation h3, div.installation h4 {
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
  }
</style>
